@if (imageUrl?.length) {
  <span
    class="absolute top-0 left-0 w-full h-full bg-[#a28f6e] bg-contain bg-center bg-no-repeat rounded-t-[3px]"
    style="background-image: url('{{ imageUrl }}');"
    >
  </span>
} @else {
  <span
    class="absolute top-0 left-0 w-full h-full bg-[#a28f6e] bg-contain bg-center bg-no-repeat rounded-t-[3px] flex items-center justify-center"
    [style.background-image]="'url(' + getFallbackImage() + ')'">
    @if (isLoading) {
      <span class="absolute inset-0 flex items-center justify-center z-10">
        <span class="w-8 h-8 border-4 border-white border-t-transparent rounded-full animate-spin"></span>
      </span>
    }
  </span>
}
